/**
 * Created by KK on 2018/2/9.
 */
export default{
  getUrl: function () {
    //window.location是object对象格式
    let start = String(window.location).indexOf('#') + 1;
    return String(window.location).substring(start);
  }
}



// WEBPACK FOOTER //
// ./src/common/js/getUrl.js